export function capitalizeFirstLetter(str: string): string {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function lowerCaseFirstLetter(str: string): string {
  if (!str) return str;
  return str.charAt(0).toLowerCase() + str.slice(1);
}


export function convertUniqueIdToTankId(uniqueId: string): string {
  if (!uniqueId) return '';
  return uniqueId.split('_')[0] || '';
}

export function keysToCamelCase(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(v => keysToCamelCase(v));
  } else if (obj !== null && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      acc[lowerCaseFirstLetter(key)] = keysToCamelCase(obj[key]);
      return acc;
    }, {} as any);
  }
  return obj;
}
